import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";

export const useRegionsIds = () => {
    const regions = useSelector((state: IRPStore) => state.propertyConfigurator.formValues.search?.regions);

    return {
        regionsIds: Array.isArray(regions)
            ? regions.reduce((acc: number[], region) => {
                  acc.push(region.id);
                  return acc;
              }, [])
            : []
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";

export const useRegionsIds = () => {
    const regions = useSelector((state: IRPStore) => state.propertyConfigurator.formValues.search?.regions);

    return {
        regionsIds: Array.isArray(regions)
            ? regions.reduce((acc: number[], region) => {
                  acc.push(region.id);
                  return acc;
              }, [])
            : []
    };
};
